'use client';

import { Typography } from '@coolblue-development/freddy';
import { Image } from '@coolblue-development/next-image/client';
import type { Product } from '@features/product/typings';
import { useBreakpoints } from '@hooks/useBreakpoints';
import { useTranslation } from '@i18n/useTranslation';

import { Banner, POOSBannerContainer } from './ImageGallery.styled';

type POOSBannerProps = {
  product: Product;
};

export function POOSBanner({ product }: POOSBannerProps) {
  const { t } = useTranslation('webshop.productPage');
  const { isMobile } = useBreakpoints();

  return (
    <POOSBannerContainer justifyContent='center'>
      <Image
        imageId={product.primaryImage.id}
        fileCollection='product'
        width={392}
        height={392}
        alt={t('productIsPermanentlyOutOfStock', {
          productName: product.name
        })}
        loading='eager'
        fullHeight
        fullWidth
      />
      <Banner alignItems='center' direction='column' gap={100} p={500}>
        <Typography variant='h3' mb={0}>
          {t('permanentlyOutOfStock')}
        </Typography>
        <Typography variant='caption'>
          {isMobile ? t('viewAlternativesBelow') : t('viewAlternatives')}
        </Typography>
      </Banner>
    </POOSBannerContainer>
  );
}
